module.exports = __webpack_public_path__ + "static/img/1_1_3_2.52b3425b.jpg";